/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MoveUpDownIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Move Up Down',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M23.517 6.311A1 1 0 0 1 22.8 8H20v6h-6V8h-2.778a1.006 1.006 0 0 1-.722-1.707L17 0ZM23.5 29.707A1.006 1.006 0 0 0 22.778 28H20v-6h-6v6h-2.8a1 1 0 0 0-.715 1.689L17 36Z"
    />
    <rect height="4" rx="1" ry="1" width="30" x="2" y="16" />
  </svg>`;
};
